module.exports = __webpack_public_path__ + "img/甘肃都市调频_03.4cd8f000.jpg";